import DefaultTheme from './default';
import theme1 from './theme1';
export default {
    default: DefaultTheme,
    theme1: theme1
};
